<template>
	<section>
		<div class="file-upload__row">
			<p>{{ $t('admin.drag_n_drop') }}</p>
			<label for="file" class="button__primary">{{
				$t('buttons.select_file')
			}}</label>
			<input
				type="file"
				id="file"
				@change="handleInput"
				:disabled="isUpdating"
				ref="input-file"
				:multiple="false"
			/>
		</div>
		<div
			v-cloak
			@drop.prevent="addFile"
			@dragover.prevent
			:class="[
				{
					'is-updating': isUpdating
				},
				'file-upload'
			]"
		>
			<div v-if="file" class="image">
				<!-- <i class="admin__delete foundicon-remove" @click="removeFile"></i> -->
				<img :src="file.preview" :alt="file.file.name" />
				<p class="u__text-center u__width-100">{{ file.file.name }}</p>
			</div>
		</div>
		<p class="error">{{ error }}</p>
	</section>
</template>
<script>
export default {
	props: {
		item: {
			type: Object,
			default: () => {}
		},
		isUpdating: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			error: '',
			fileTypes: ['jpg', 'jpeg', 'png', 'mp4', 'mov'],
			file: this.item
		}
	},
	created() {
		if (!this.item) {
			this.file = null
		}
	},
	methods: {
		handleInput() {
			this.error = ''
			this.$refs['input-file'].files.forEach((file) => this.previewFile(file))
			this.$refs['input-file'].value = ''
		},
		addFile(e) {
			if (!this.isUpdating) {
				let droppedFiles = e.dataTransfer.files
				if (!droppedFiles) return
				this.error = ''
				if (droppedFiles[droppedFiles.length - 1]) {
					this.previewFile(droppedFiles[droppedFiles.length - 1])
				}
			}
		},
		removeFile() {
			if (!this.isUpdating) {
				this.error = ''
				this.file = null
			}
		},
		previewFile(file) {
			if (this.checkExt(file.name)) {
				const reader = new FileReader()
				reader.readAsDataURL(file)
				reader.onloadend = () => {
					this.file = {
						file,
						preview: this.isVideo(file.name)
							? this.$getImgUrl('video_icon.png')
							: reader.result,
						uploaded: false
					}
					this.$emit('update-file', this.file)
				}
			}
		},
		checkExt(name) {
			const ext = name
				.split('.')
				.pop()
				.toLowerCase()
			const isSuccess = this.fileTypes.includes(ext)
			if (!isSuccess) {
				this.error = this.$t('errors.file_wrong_ext')
			}
			return isSuccess
		},
		isVideo: (name) =>
			name.split('.')[1] === 'mp4' || name.split('.')[1] === 'mov' ? true : false
	}
}
</script>
